// extracted by mini-css-extract-plugin
export default {"cardList":"cardList_xd3bwHB","card":"card_UAZpCgS"};